import type { FeatureData } from "./models";
import { NumberFormatter } from "~/common/utils/NumberFormatter";

export function renderTechValue(value: string, isInch: boolean, isConverted = false): JSX.Element {
  const isNumber = value.trim() !== "" && !Number.isNaN(Number(value));
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: isNumber ? NumberFormatter.getDefaultFormatter().format(Number(value)) : value,
      }}
    />
  );
}

export function renderTechValueSrpTable(feature: FeatureData, value: string): JSX.Element {
  return <span dangerouslySetInnerHTML={{ __html: value }} />;
}
